<div class="flex flex-col p-6 w-full h-full">
  <div class="flex justify-between items-center pb-6">
    <h2 class="text-lg font-semibold text-gray-900">Add Appointment</h2>
    <img [src]="assetUrl + 'icons/x-close.svg'" class="w-5 h-5" alt="Close" />
  </div>

  <div class="flex flex-col w-full flex-grow">
    <!-- Step 2 -->
    <!-- <div class="flex flex-col flex-grow">
            <div class="flex items-center gap-4 pb-4">
                <div class="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-sm font-semibold text-gray-600">
                    DW
                </div>
                <span class="text-sm font-medium text-gray-900">Dian Wilkinson</span>
            </div>

            <div class="flex flex-col gap-2 pb-4">
                <div class="flex items-center gap-2 text-sm text-gray-600">
                    <img [src]="assetUrl + 'icons/calendar.svg'" class="w-4 h-4" />
                    <span>Fri, 08 Mar 2025</span>
                </div>
                <div class="flex items-center gap-2 text-sm text-gray-600">
                    <img [src]="assetUrl + 'icons/clock.svg'" class="w-4 h-4" />
                    <span>09:00 AM (2 hours duration)</span>
                </div>
            </div>

            <div class="pb-6">
                <span class="flex items-center gap-2 text-sm text-gray-700 border border-gray-200 rounded-full px-3 py-1 w-fit">
                    <img [src]="assetUrl + 'icons/tag-avatar.png'" class="w-5 h-5 rounded-full object-cover" />
                    Service by <b>Helen</b>
                </span>
            </div>

            <div class="flex flex-col gap-3 pb-6">
                <div class="flex justify-between items-center border border-gray-200 rounded-xl p-4">
                    <div class="flex flex-col text-sm">
                        <span class="font-medium text-gray-900">Haircut</span>
                        <span class="text-gray-600">1 hr, 30 mins</span>
                    </div>
                    <span class="font-semibold text-sm text-gray-900">$15,00</span>
                </div>

                <div class="flex justify-between items-center border border-gray-200 rounded-xl p-4">
                    <div class="flex flex-col text-sm">
                        <span class="font-medium text-gray-900">Hair Coloring</span>
                        <span class="text-gray-600">1 hr, 30 mins</span>
                    </div>
                    <span class="font-semibold text-sm text-gray-900">$15,00</span>
                </div>

                <div class="flex justify-end pt-1">
                    <glo-button icon="plus-dark" type="white" value="Add Service"></glo-button>
                </div>
            </div>
        </div>

        <div class="flex justify-between items-center pt-4 pb-6 text-sm font-medium text-gray-900">
            <span>Total</span>
            <span>$30,00</span>
        </div> -->

    <!-- Step1 -->
    <form class="flex flex-col gap-5">
      <label class="flex flex-col text-sm text-gray-800">
        Select Date
        <glo-control
          icon="calendar"
          placeholder="Tue, Jan 6, 2026"
        ></glo-control>
      </label>

      <label class="flex flex-col text-sm text-gray-800">
        Time
        <input type="text" class="dropdown" value="10.00 AM" />
      </label>

      <label class="flex flex-col text-sm text-gray-800">
        Client name
        <input type="text" class="dropdown" value="Maria Helena" />
      </label>

      <label class="flex flex-col text-sm text-gray-800">
        Handle by
        <input type="text" class="dropdown" value="Olivia Rhye" />
      </label>

      <label class="flex flex-col text-sm text-gray-800">
        Select Service
        <input type="text" class="dropdown" placeholder="Choose" />
      </label>
    </form>
    <!-- Footer Buttons fixed at bottom -->
    <div class="flex pt-6 border-t border-gray-200 justify-end gap-4 mt-auto">
      <button class="px-6 py-2 shadow rounded-3xl bg-white text-gray-950">
        Cancel
      </button>
      <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">
        Next
      </button>
    </div>
  </div>
</div>
